import { render, staticRenderFns } from "./relevance-form.vue?vue&type=template&id=79bd54a3&"
import script from "./relevance-form.vue?vue&type=script&lang=ts&"
export * from "./relevance-form.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports